export enum Colors {
  azul = 'rgba(100,100,250,1)',
  fucsia = 'rgba(247,51,247,1)',
  verde = '#7BDCAD',
  amarelo = 'rgba(251,251,75,1)',
  laranja = 'rgba(255,128,0,1)',
  vermelho = '#FD1A1A',
  text = '#292929'
}
